export interface IUserData {
	skipPayment?: boolean;
	idUsuario?: string;
	nomeCompleto?: string;
	dataNascimento?: string;
	cpf?: string;
	celular?: string;
	nomeSocial?: string;
	sexoBiologico?: "Feminino" | "Masculino";
	app?: boolean;
	email?: string;
	procedureId?: string;
}

const getUserData = (): IUserData => {
	try {
		let response: IUserData = {};
		response = JSON.parse(window.sessionStorage.getItem("user_data") || "");
		if ((response.sexoBiologico as string) === "M") response.sexoBiologico = "Masculino";
		if ((response.sexoBiologico as string) === "F") response.sexoBiologico = "Feminino";
		return response;
	} catch (err) {
		return {};
	}
};

export default getUserData;
